import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'

import { adminOrganizationsApi } from '@/features/admin/api/organizations.api'

export function useAdminOrganizationsQuery(params: { q?: string; status?: string; per_page?: number; page?: number } = {}) {
  return useQuery({
    queryKey: ['admin', 'organizations', params],
    queryFn: () => adminOrganizationsApi.list(params),
  })
}

export function useOrgRecruitersQuery(orgId: number | null) {
  return useQuery({
    queryKey: ['admin', 'organizations', orgId, 'recruiters'],
    queryFn: () => adminOrganizationsApi.recruiters(orgId!),
    enabled: orgId !== null,
  })
}

export function useOrgHiresQuery(orgId: number | null, enabled: boolean) {
  return useQuery({
    queryKey: ['admin', 'organizations', orgId, 'hires'],
    queryFn: () => adminOrganizationsApi.hires(orgId!),
    enabled: orgId !== null && enabled,
  })
}

export function useUpdateOrgStatus() {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: ({ orgId, status }: { orgId: number; status: string }) =>
      adminOrganizationsApi.updateStatus(orgId, status),
    onSuccess: () => void queryClient.invalidateQueries({ queryKey: ['admin', 'organizations'] }),
  })
}
